import { StoreState } from "../../../store/store.interface";

export const areFreeTrialTermsAccepted = (state: StoreState) => state.freeTrialState.freeTrialTerms.accepted;

export const getFreeTrialAvailabilityData = (state: StoreState) => state.freeTrialState.freeTrialAvailability.data;

export const getFreeTrialCancelData = (state: StoreState) => state.freeTrialState.freeTrialCancel.data;

export const getFreeTrialCancelStatus = (state: StoreState) => state.freeTrialState.freeTrialCancel.status;

export const getFreeTrialConvertedIsbns = (state: StoreState) => state.freeTrialState.freeTrialConversion.convertedIsbns;
